<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav"/>
    <div class="record-depot">
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name"> <i class="song"></i>曲目一览 </span>
          </div>
        </div>
        <div class="depot-list-box">
          <div class="left-filter">
             <div class="ft-box" v-if="coDict && coDict.length > 0">
              <div class="tit">
                <i></i>责任者
                <span
                  :class="showAll[0] ? 'cur' : ''"
                  @click="showAllHandle(0)"
                ></span>
              </div>
              <div :class="showAll[0] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === coCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'co')"
                >
                  <span>全部</span>
                  <!-- <span>{{ coCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in coDict"
                  :key="'coDict' + index"
                  :class="getFacetText('coDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'co')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
          
            <div class="ft-box" v-if="genreDict && genreDict.length > 0">
              <div class="tit">
                <i></i>体裁
                <span
                  :class="showAll[1] ? 'cur' : ''"
                  @click="showAllHandle(1)"
                ></span>
              </div>
              <div :class="showAll[1] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === genreCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'genre')"
                >
                  <span>全部</span>
                  <!-- <span>{{ genreCount }}</span> -->
                </div>
                <div
                  v-for="(item, index) in genreDict"
                  :key="'genreDict' + index"
                 :class="getFacetText('genreDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'genre')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
              <div class="ft-box" v-if="bandDict && bandDict.length > 0">
              <div class="tit">
                <i></i>乐队
                <span
                  :class="showAll[2] ? 'cur' : ''"
                  @click="showAllHandle(2)"
                ></span>
              </div>
              <div :class="showAll[2] ? 'ft-lt cur' : 'ft-lt'">
                <div
                  :class="-1 === bandCurrent ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'band')"
                >
                  <span>全部</span>
                  <span>{{ bandCount }}</span>
                </div>
                <div
                  v-for="(item, index) in bandDict"
                  :key="'bandDict' + index"
                  :class="getFacetText('bandDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'band')"
                >
                  <span>{{ item.facet }}</span>
                  <span>{{ item.count }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right-content">
            <a-spin class="page-load" v-if="pageLoad" />
            <div v-else>
              <div class="result-count">
                <span
                  >共<b>{{ rowCount }}</b
                  >首</span
                >
                <div
                  :class="
                    showMobileFilter ? 'mb-filter-btn cur' : 'mb-filter-btn'
                  "
                  @click.stop="showMobileFilter = !showMobileFilter"
                >
                  筛选
                </div>
                <div class="sort">
                  <span :class="sort.field === 'TI' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TI')"
                    >题名</span
                  >
                  <span :class="sort.field === 'CO' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('CO')"
                    >责任者</span
                  >
                  <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放曲目</span
                >
                </div>
              </div>
              <div class="filter-keys" v-if="filterKeys.length > 0">
                <div class="lb">已选项：</div>
                <div
                  v-for="(f, index) in filterKeys"
                  :key="index + f.text"
                  class="f-k"
                >
                  {{ f.text }} <i class="cls" @click="deleteFilter(index)"></i>
                </div>
              </div>
              <div class="result-list">
                <div
                  v-for="(item, index) in recordList"
                  :key="'recordList' + index"
                  class="result-cell song-lt"
                >
                  <div class="index">{{ index + 1 }}</div>
                  <div class="pic">
                    <router-link
                      :to="'/song-detail/' + encodeURIComponent(item['@id'])"
                    >
                      <img :src="item.img || baseMusicPic" alt="" />
                      <!-- <img :src="item.img ||'/img/basemusic.png'" alt="" v-if="item.img ||'/img/basemusic.png'"> -->
                      <!-- <a-empty v-else :description="'暂无图片'" /> -->
                      <!-- <img v-else src="img/demo/image.png" alt=""> -->
                    </router-link>
                  </div>
                  <div class="info">
                       <router-link
                      :to="'/song-detail/' + encodeURIComponent(item['@id'])"
                    >
                    <div
                      class="name"
                      v-if="item.dctitle"
                      :title="item.dctitle['@value']"
                    >
                        {{ item.dctitle["@value"].replace(/~/,'')}}
                    </div>
                    <div class="des" v-if="item.creator">
                      <!-- <span>责任者</span>责任方式 -->
                      <span>{{
                        Array.isArray(item.creator)
                          ? item.creator.join("\xa0\xa0\xa0")
                          : item.creator
                      }}</span>
                    </div>
                        </router-link>
                     <router-link
                      :to="'/song-detail/' + encodeURIComponent(item['@id'])"
                    >
                    <div class="des" v-if="item.language">
                      语种：<span>{{ item.language }}</span>
                    </div>
                     </router-link>
                    <!-- <div class="des">
                    来自唱片<span>唱片名称</span>
                  </div> -->
                  </div>
                  
                  <div class="count" v-if="item.extent">
                    {{ item.extent }}
                  </div>
                  <div class="act">
                    <span v-if="!item.playable" class="noplay"></span>
                 <span v-if="item.playable" :class="playIndex == index ? 'play curPlay' : 'play'" @click="playSong(item,index)"></span>
                 
                    <span
                      :class="item.isFavorite ? 'fav cur' : 'fav'"
                      @click="handleFav(index)"
                    ></span>
                    <!-- <span class="share"></span> -->
                    <ShareIcon
                      :shareConfig="{
                        url: '/song-detail/' + encodeURIComponent(item['@id']),
                        title: item.dctitle['@value'],
                      }"
                    ></ShareIcon>
                  </div>
                </div>
              </div>
              <div class="page-box">
                <a-pagination
                  :total="pagerCount"
                  :current="currentPage"
                  @change="onChange"
                  show-quick-jumper
                  show-less-items
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Player ref="player" @saveFav="saveFav" @curPlay="curPlay"/>
    <div
      :class="showMobileFilter ? 'mobile-filter-tk cur' : 'mobile-filter-tk'"
    >
          <div class="depot-filter" v-if="coDict && coDict.length > 0">
        <span class="lb">责任者</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + coDict.length * 1.4 + 'rem'">
              <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
         
            <span
              :class="coCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1,-1, 'co')"
              >全部</span
            >
            <span
              v-for="(item, index) in coDict"
              :key="'coDict' + index"
              :class="getFacetText('coDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item,index, 'co')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="depot-filter" v-if="genreDict && genreDict.length > 0">
        <span class="lb">体裁</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + genreDict.length * 1.4 + 'rem'">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="genreCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1,-1, 'genre')"
              >全部</span
            >
            <span
              v-for="(item, index) in genreDict"
              :key="'genreDict' + index"
             :class="getFacetText('genreDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item,index, 'genre')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
     
      <div class="depot-filter" v-if="bandDict && bandDict.length > 0">
        <span class="lb">乐队</span>
        <div class="scroll-box">
          <div class="fs" :style="'width:' + bandDict.length * 1.4 + 'rem'">
             <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
            <span
              :class="bandCurrent === -1 ? 'cur' : ''"
              @click="handleFilter(-1,-1, 'band')"
              >全部</span
            >
            <span
              v-for="(item, index) in bandDict"
              :key="'bandDict' + index"
              :class="getFacetText('bandDict').indexOf(item.facet)>=0 ? 'cur' : ''"
              @click="handleFilter(item,index, 'band')"
            >
              {{ item.facet }} <i>{{ item.count }}</i>
            </span>
          </div>
        </div>
      </div>
          <div class="depot-filter">
          <div class="sort">
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放曲目</span
                >
              </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import ShareIcon from "@/components/shareIcon";
import { baseMusicPic } from "@/util/basePic";
import { musicSearch, collFav, ncollFav } from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player,
    ShareIcon,
  },
  data() {
    return {
      playIndex:-1,
      curIndex:-1,
      sc:false,
      loginHref:null,
      visible:false,
      noplay:false,
      sc:false,
      pageLoad: false,
      playerList: [],
      player: [],
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {},
      showMobileFilter: false,
      baseMusicPic,
      listType: 1,
      subjectCount: 0,
      subjectCurrent: -1,
      subjectDict: [],
      genreCount: 0,
      genreCurrent: -1,
      genreDict: [],
      artStyleCount: 0,
      artStyleCurrent: -1,
      artStyleDict: [],
      ariaCount: 0,
      ariaCurrent: -1,
      ariaDict: [],
      instrumentCount: 0,
      instrumentCurrent: -1,
      instrumentDict: [],
      bandCount: 0,
      bandCurrent: -1,
      bandDict: [],
      loginHref:null,
      extentCount: 0,
      extentCurrent: -1,
      extentDict: [],
      coCount: 0,
      coCurrent: -1,
      coDict: [],
      audioDetail: [],
      facesTitleKey: [
        { key: "subject", title: "题材" },
        { key: "genre", title: "体裁" },
        { key: "artStyle", title: "风格流派" },
        { key: "aria", title: "唱法唱腔" },
        { key: "instrument", title: "乐器" },
        { key: "band", title: "乐队" },
        { key: "extent", title: "歌曲时长" },
        { key: "co", title: "责任者" },
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      hasAudio: false,
      onlyShowPlay: false,
      totalPage: 10, // 每页总数
      recordList: [],
      showAll: [
        true,
        true,
        true
      ],
      filterKeys: [],
      sort: {
        field: "TI",
        order: "asc"
      }
    };
  },
  mounted() {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href
    this.$nextTick(() => {
      document.body.addEventListener("click", () => {
        this.showMobileFilter = false;
      });
      this.searchParams = this.commonParamsHandling();
      if(this.GLOBAL.BASE_IP_INFO.ipIsInner){//如果是内网，直接勾选可播放按钮 chenss 20220831
        this.onlyShowPlay = true;
        this.hasAudio = this.onlyShowPlay;
      }
      this.query();
    });
  },
  
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer()
    next();
  },
  beforeDestroy() {
    document.body.removeEventListener("click", () => {
      this.showMobileFilter = false;
    });
  },
  methods: {
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      this.query();
    },
    initData() {
      // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    onParamsHandle() {
      // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      // 排序
      const { field, order } = this.sort;
      this.searchParams.sorts = {
        [field]: order === "asc" ? 1 : 0
      };
     
      //仅显示可播放的唱片
       if (this.hasAudio)
        // this.searchParams.facet = { hasAudio: this.hasAudio + "" };
        this.searchParams.resouce = { PLAY: "1" };
      // 页码翻页
      this.searchParams.pager = {
        pageth: this.currentPage,
        pageSize: this.totalPage,
      };
      if (this.filterKeys.length < 1) return;
      this.filterKeys.forEach((item, index) => {
        const dict = item.dict;
        // 简单检索
        if (dict == "keyword") {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if (dict.indexOf("Dict") != -1) {
          this.searchParams.facet[dict.replace("Dict", "").toUpperCase()] =item.text;
          
        }
      });
    },
    async query(facetsFlag = true) {
      // this.pageLoad = true;是否刷新画面
      // 参数设置
      this.onParamsHandle();
      const res = await musicSearch(this.searchParams);
      //console.log(res);
      if (res) {
        this.pageLoad = false;
      }
      const data = res.data;
      // 内容
      this.recordList = data.datas;
      // 分面
      if (facetsFlag) {
        // 题材
        this.subjectDict =
          data.facets && data.facets.subjectFacet
            ? data.facets.subjectFacet
            : [];
        // 体裁
        this.genreDict =
          data.facets && data.facets.genreFacet ? data.facets.genreFacet : [];
        // 风格流派
        this.artStyleDict =
          data.facets && data.facets.artStyleFacet
            ? data.facets.artStyleFacet
            : [];
        // 唱法唱腔
        this.ariaDict =
          data.facets && data.facets.ariaFacet ? data.facets.ariaFacet : [];
        // 乐器
        this.instrumentDict =
          data.facets && data.facets.instrumentFacet
            ? data.facets.instrumentFacet
            : [];
        // 乐队
        this.bandDict =
          data.facets && data.facets.bandFacet ? data.facets.bandFacet : [];
        // 歌曲时长
        this.extentDict =
          data.facets && data.facets.extentFacet ? data.facets.extentFacet : [];
        // 责任者
        this.coDict =
          data.facets && data.facets.coFacet ? data.facets.coFacet : [];
      }
      // 统计数量
      this.facesTitleKey.forEach((item, index) => {
        this.countHnadle(item.key);
      });
      // 总数
      this.rowCount =
        data.pager && data.pager.rowCount ? data.pager.rowCount : 0;
      // 页码
      this.pagerCount =
        data.pager && data.pager.rowCount ? data.pager.rowCount : 1;
    },
    countHnadle(key) {
      // 统计数量
      this[key + "Count"] = 0;
      this[key + "Dict"].forEach((item, index) => {
        this[key + "Count"] += item.count;
      });
    },
    handleSortChange(field) {
      if (field === this.sort.field) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.field = field;
        this.sort.order = "asc";
      }
      this.query(false);
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.query(false);
    },
    showAllHandle(a) {
      this.showAll.splice(a, 1, !this.showAll[a]);
      let count = 0;
      this.showAll.forEach((item) => {
        if (item) {
          count++;
        }
      });
      // if (count > 3) {
      //   let flag = false;
      //   this.showAll.forEach((item, index) => {
      //     if (item && index !== a && !flag) {
      //       flag = true;
      //       this.showAll.splice(index, 1, false);
      //     }
      //   });
      // }
    },
    async handleFav(index) {
      //点击收藏如果没有登录,则提示用户登录后方可操作
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.recordList[index].isFavorite ? await ncollFav({ uri: this.recordList[index]["@id"] }) : await collFav({ uri: this.recordList[index]["@id"] });
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      this.$refs.player.saveFav(this.recordList[index]);
      
      this.$refs.Nav.cpnclick(this.recordList[index].isFavorite);
    },
    saveFav(data){
      this.recordList.forEach((i, k) => {
        if(i['@id'] == data['singer']){
         this.recordList[k]['isFavorite'] = !this.recordList[k]['isFavorite']
        }
      })
    },
    deleteFilter(index) {
      this[
        this.filterKeys[index].dict.substring(
          0,
          this.filterKeys[index].dict.search("Dict")
        ) + "Current"
      ] = -1;
      this.filterKeys.splice(index, 1);
      this.currentPage = 1;
      this.query();
    },
    getFacetText(key) {
     const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key ;
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      if(this.filterKeys[_i]){  return this.filterKeys[_i].text;}
      return '';
    },
    handleFilter(item, index, key) {
      
      this[key + "Current"] = item.facet ? item.facet : item;//被选中的分面值
      const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key + "Dict";
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      let facValue = this[key + "Dict"][index] && this[key + "Dict"][index].facet ? this[key + "Dict"][index].facet :'';//真正选中的分面值
      if (_i !== -1) {
          //如果是专题，则可以多选
          if(this.filterKeys[_i]){
            let tempList =this.filterKeys[_i].text.split(',');
              if(tempList.indexOf(facValue)==-1){//如果已转中数组中不存在当前值，则继续存入
                  if(facValue !=null && facValue!=''){
                  tempList.push(facValue);//被选中的主题分类数据
                  this.filterKeys[_i].text=tempList.join(',');
                  }
                  }
               else if(tempList.length>1) {//如果剩下的不是最后一个时候，允许移除
                tempList.splice(tempList.indexOf(facValue),1);//如果存在，则删除该值，重新查询
              }
              facValue =tempList.join(',');
           }
          if (index === -1) {
            this.filterKeys.splice(_i, 1);
            console.log('index === -1')
          } else {
            this.filterKeys.splice(_i, 1, {dict: key + "Dict", text: facValue});
          }
      } else if(facValue !=null && facValue!=''){//选中的分面值，如果不为空 做新增
           this.filterKeys.push({dict: key + "Dict", text: facValue});
      }
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    curPlay(){
      this.playIndex = this.curIndex;
    },
    playSong(item,index) {
      if(this.playIndex == index){
        this.playIndex = -1;
        this.$refs.player.play();
        return;
      }
      this.curIndex = index;
      this.$refs.player.playSingleSong(this.$refs.Nav, item);
    },
  },
};
</script>
